"use client";

import { FC } from "react";
import NextImage from "next/image";

import { useStyles } from "./styles";
import { Image as TImage } from "@/types/thread";

interface ZoomImageProps {
  image: TImage;
  onImageLoad?: () => void;
}

const ZoomImage: FC<ZoomImageProps> = ({ image, onImageLoad }) => {
  const { classes } = useStyles();

  if (!image?.url) return null;

  return (
    <NextImage
      unoptimized
      src={image.url}
      alt={image.alt || ""}
      width={300}
      height={300}
      className={classes.image}
      onLoad={onImageLoad}
    />
  );
};

export default ZoomImage;
